/**
 * Main PDP add-to-cart, pack-aware.
 *
 * The store's cart_type is "page", so the main product form would natively
 * submit and redirect to /cart. We intercept every submit and go through the
 * Ajax Cart API instead, then navigate to /cart ourselves. The shopper sees the
 * same thing; the difference is that Shopify gets to observe the add.
 *
 * That observation is the whole point. The `product_added_to_cart` web pixel
 * standard event — which is what Meta's pixel app turns into AddToCart — is
 * emitted for /cart/add.js calls. A full-page POST to /cart/add tears down the
 * JS context before anything can see it, so while this script only stepped in
 * for upsell packs, a plain add fired no AddToCart at all.
 *
 * When the shopper picked an upsell card (see product-upsell.js) that product
 * rides along in the same /cart/add.js call.
 */
(function () {
  function shopifyRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root
      ? Shopify.routes.root
      : '/';
  }

  function isMainProductForm(form) {
    return !!(
      form &&
      form.classList &&
      form.classList.contains('product-purchase-form') &&
      form.closest('.product-form[data-ajax-add-to-cart="true"]')
    );
  }

  document.addEventListener(
    'submit',
    function (evt) {
      var form = evt.target;
      if (!isMainProductForm(form)) return;

      // Any upsell card the shopper picked rides along in the same call.
      var selectedIds = document.querySelectorAll(
        '.product-upsell .upsell-card.selected .upsell-card__form input[name="id"]'
      );

      // The theme's product form posts the variant as `id[]`, not `id`.
      var formData = new FormData(form);
      var mainVariantId = formData.get('id[]') || formData.get('id');
      if (!mainVariantId) return;

      evt.preventDefault();

      var button = form.querySelector('button[type="submit"]');
      if (button) button.setAttribute('disabled', 'disabled');

      var items = [
        {
          id: mainVariantId,
          quantity: parseInt(formData.get('quantity') || '1', 10) || 1
        }
      ];
      Array.prototype.forEach.call(selectedIds, function (input) {
        if (input.value) items.push({ id: input.value, quantity: 1 });
      });

      fetch(shopifyRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('cart/add.js responded ' + response.status);
          }
          return response.json();
        })
        .then(function () {
          window.location.href = shopifyRoot() + 'cart';
        })
        .catch(function () {
          if (button) button.removeAttribute('disabled');
          // A plain add used to be a native POST, so fall back to one. That
          // keeps Shopify's own error handling (sold out, cart limits) as what
          // the shopper sees, rather than a button that silently re-enables.
          // form.submit() dispatches no submit event, so this cannot re-enter
          // the handler. A pack add keeps the old behaviour instead: retrying
          // natively would drop the upsell and add only the main product.
          if (!selectedIds.length) form.submit();
        });
    },
    false
  );

  // Back/forward navigation to the PDP serves a cached page reflecting the
  // pre-add cart, so the cart bubble, upsell visibility and button state are
  // stale. This happens two ways: the bfcache snapshot (evt.persisted true) or
  // a disk-cached HTML re-render (navigation type "back_forward", persisted
  // false — this is the common case here). Handle both: reload so the server
  // re-renders against the current cart. reload() flips the navigation type to
  // "reload", so this fires once and never loops.
  window.addEventListener('pageshow', function (evt) {
    var nav = performance.getEntriesByType('navigation')[0];
    if (evt.persisted || (nav && nav.type === 'back_forward')) {
      window.location.reload();
    }
  });
})();
